exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fields-restricted-manager[data-v-2c080471] {\n    margin-bottom: 20px;\n}\n", ""]);

// exports
